<adc-header *ngIf="showHeaderAndFooter"></adc-header>
<main id="main" class="grid-container" role="main" aria-label="main content">
  <router-outlet></router-outlet>
</main>
<adc-footer *ngIf="showHeaderAndFooter"></adc-footer>
